// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonNext__wrap--ZEc","button":"ButtonNext__button--2P9"};